import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/Instagram.svg'

export const IconInstagram = IconSVG as IconComponent
